(function () {
  'use strict';

  var STORAGE_KEY = 'tr_quote_state_v1';
  var WHATSAPP_NUMBER = '56956185788';
  var WORKER_URL = 'https://trauko-cotizador.pablo-338.workers.dev/';

  var drawer, currentStep = 1;
  var state = {
    products: [],
    technique: 'Sin personalización',
    techniques: ['Sin personalización'],
    services: [],
    comments: '',
    contact: {}
  };

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        state = Object.assign(state, parsed);
      }
    } catch (e) { /* ignore */ }
    if (!state.products || state.products.length === 0) {
      state.products = [{ name: '', color: '', qty: 1, image: '' }];
    }
    // Compatibilidad con sesiones guardadas antes de soportar múltiples
    // personalizaciones (donde solo existía state.technique como string).
    if (!state.techniques || !state.techniques.length) {
      state.techniques = state.technique ? [state.technique] : ['Sin personalización'];
    }
    state.technique = state.techniques.join(', ');
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore */ }
    try {
      window.dispatchEvent(new CustomEvent('tr:quote-updated'));
    } catch (e) { /* ignore */ }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // ------------------------- PASO 1: productos -------------------------

  function renderProducts() {
    var list = document.getElementById('tr-quote-products-list');
    if (!list) return;
    list.innerHTML = '';

    state.products.forEach(function (product, index) {
      var row = document.createElement('div');
      row.className = 'tr-quote-product-row';
      var thumb = product.image
        ? '<img class="tr-quote-product-row__thumb" src="' + product.image + '" alt="">'
        : '<span class="tr-quote-product-row__thumb tr-quote-product-row__thumb--placeholder"></span>';

      row.innerHTML =
        '<div class="tr-quote-product-row__name-wrap">' +
          thumb +
          '<div class="tr-quote-product-row__name-fields">' +
            '<input type="text" class="tr-quote-product-row__name" placeholder="Nombre del producto" value="' + escapeHtml(product.name) + '" autocomplete="off">' +
            '<input type="text" class="tr-quote-product-row__color" placeholder="Color" value="' + escapeHtml(product.color) + '">' +
          '</div>' +
          '<div class="tr-quote-autocomplete" hidden></div>' +
        '</div>' +
        '<div class="tr-quote-product-row__qty">' +
          '<button type="button" class="tr-quote-qty-btn" data-qty-minus aria-label="Restar">\u2212</button>' +
          '<input type="number" class="tr-quote-qty-input" min="1" value="' + product.qty + '">' +
          '<button type="button" class="tr-quote-qty-btn" data-qty-plus aria-label="Sumar">+</button>' +
        '</div>' +
        '<button type="button" class="tr-quote-product-row__remove" aria-label="Eliminar">\u{1F5D1}</button>';

      var nameInput = row.querySelector('.tr-quote-product-row__name');
      var autocompleteBox = row.querySelector('.tr-quote-autocomplete');
      var autocompleteTimer = null;

      nameInput.addEventListener('input', function (e) {
        state.products[index].name = e.target.value;
        state.products[index].image = '';
        state.products[index].id = '';
        saveState();

        var query = e.target.value.trim();
        clearTimeout(autocompleteTimer);
        if (query.length < 2) {
          autocompleteBox.hidden = true;
          autocompleteBox.innerHTML = '';
          return;
        }
        autocompleteTimer = setTimeout(function () {
          fetchProductSuggestions(query, function (products) {
            renderAutocomplete(autocompleteBox, products, function (chosenName, chosenImage) {
              nameInput.value = chosenName;
              state.products[index].name = chosenName;
              state.products[index].image = chosenImage || '';
              saveState();
              renderProducts();
              renderSidebarCart();
            });
          });
        }, 250);
      });

      nameInput.addEventListener('blur', function () {
        setTimeout(function () { autocompleteBox.hidden = true; }, 150);
      });
      nameInput.addEventListener('focus', function () {
        if (autocompleteBox.innerHTML !== '') autocompleteBox.hidden = false;
      });

      row.querySelector('.tr-quote-product-row__color').addEventListener('input', function (e) {
        state.products[index].color = e.target.value;
        saveState();
        renderSidebarCart();
      });
      row.querySelector('[data-qty-plus]').addEventListener('click', function () {
        state.products[index].qty += 1;
        renderProducts();
        renderSidebarCart();
        saveState();
      });
      row.querySelector('[data-qty-minus]').addEventListener('click', function () {
        state.products[index].qty = Math.max(1, state.products[index].qty - 1);
        renderProducts();
        renderSidebarCart();
        saveState();
      });
      row.querySelector('.tr-quote-qty-input').addEventListener('input', function (e) {
        var val = parseInt(e.target.value, 10);
        state.products[index].qty = isNaN(val) || val < 1 ? 1 : val;
        renderSidebarCart();
        saveState();
      });
      row.querySelector('.tr-quote-qty-input').addEventListener('blur', function (e) {
        e.target.value = state.products[index].qty;
      });
      row.querySelector('.tr-quote-product-row__remove').addEventListener('click', function () {
        state.products.splice(index, 1);
        if (state.products.length === 0) {
          state.products.push({ name: '', color: '', qty: 1, image: '' });
        }
        renderProducts();
        renderSidebarCart();
        saveState();
      });

      list.appendChild(row);
    });
  }

  function fetchProductSuggestions(query, callback) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        callback(products);
      })
      .catch(function () { callback([]); });
  }

  function renderAutocomplete(box, products, onSelect) {
    if (!products.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      return (
        '<button type="button" class="tr-quote-autocomplete__item" data-name="' + escapeHtml(p.title) + '" data-image="' + escapeHtml(img) + '">' +
          (img ? '<img class="tr-quote-autocomplete__img" src="' + img + '" alt="" loading="lazy">' : '<span class="tr-quote-autocomplete__img tr-quote-autocomplete__img--placeholder"></span>') +
          '<span class="tr-quote-autocomplete__name">' + escapeHtml(p.title) + '</span>' +
        '</button>'
      );
    }).join('');
    box.hidden = false;
    box.querySelectorAll('.tr-quote-autocomplete__item').forEach(function (btn) {
      btn.addEventListener('mousedown', function (e) {
        e.preventDefault();
        onSelect(btn.dataset.name, btn.dataset.image);
      });
    });
  }

  // ------------------------- Resumen lateral ("Tu cotización") -------------------------

  function renderSidebarCart() {
    var targets = ['tr-quote-sidebar-cart', 'tr-quote-sidebar-cart-2', 'tr-quote-sidebar-cart-3'];
    var realProducts = state.products.filter(function (p) { return p.name.trim() !== ''; });
    var totalUnits = realProducts.reduce(function (sum, p) { return sum + (parseInt(p.qty, 10) || 0); }, 0);

    var itemsHtml = realProducts.map(function (p, i) {
      var thumb = p.image
        ? '<img class="tr-quote-summary-card__thumb" src="' + p.image + '" alt="">'
        : '<span class="tr-quote-summary-card__thumb tr-quote-summary-card__thumb--placeholder">\u{1F4E6}</span>';
      return (
        '<div class="tr-quote-summary-card__item">' +
          thumb +
          '<div class="tr-quote-summary-card__info">' +
            '<p class="tr-quote-summary-card__name">' + escapeHtml(p.name) + '</p>' +
            '<p class="tr-quote-summary-card__meta">' + (p.color ? escapeHtml(p.color) + ' \u00b7 ' : '') + p.qty + ' unidades</p>' +
          '</div>' +
          '<button type="button" class="tr-quote-summary-card__remove" data-remove-product="' + i + '" aria-label="Eliminar">\u{1F5D1}</button>' +
        '</div>'
      );
    }).join('');

    var html =
      '<p class="tr-quote-summary-card__title">Tu cotización (' + realProducts.length + ')</p>' +
      (itemsHtml || '<p class="tr-quote-summary-card__meta">Aún no agregas productos.</p>') +
      '<div class="tr-quote-summary-card__totals">' +
        '<span>Total productos: <strong>' + realProducts.length + '</strong></span>' +
        '<span>Total unidades: <strong>' + totalUnits + '</strong></span>' +
      '</div>';

    targets.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.innerHTML = html;
      el.querySelectorAll('[data-remove-product]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var realIndex = state.products.indexOf(realProducts[parseInt(btn.dataset.removeProduct, 10)]);
          if (realIndex !== -1) state.products.splice(realIndex, 1);
          if (state.products.length === 0) state.products.push({ name: '', color: '', qty: 1, image: '' });
          renderProducts();
          renderSidebarCart();
          saveState();
        });
      });
    });
  }

  // ------------------------- Personalización (combinable con reglas) -------------------------
  // Reglas:
  //  - "Sin personalización" es exclusiva: al marcarla se desmarca todo lo
  //    demás, y al marcar cualquier otra se desmarca "Sin personalización".
  //  - "cuño" y "grabado" son mutuamente excluyentes entre sí (no ambas
  //    opciones de logo a la vez), pero cualquiera de las dos SI puede
  //    combinarse con "nombres / iniciales".
  //  - La opción bloqueada por la otra queda visible, deshabilitada,
  //    atenuada y tachada (no desaparece).

  function getTechniqueInput(key) {
    if (!drawer) return null;
    return drawer.querySelector('.tr-quote-technique-input[data-technique="' + key + '"]');
  }

  function updateTechniqueDisabledStates() {
    var cuno = getTechniqueInput('cuno');
    var grabado = getTechniqueInput('grabado');
    if (!cuno || !grabado) return;

    if (cuno.checked) {
      grabado.disabled = true;
      grabado.checked = false;
      grabado.closest('.tr-quote__radio').classList.add('is-disabled');
    } else {
      grabado.disabled = false;
      grabado.closest('.tr-quote__radio').classList.remove('is-disabled');
    }

    if (grabado.checked) {
      cuno.disabled = true;
      cuno.checked = false;
      cuno.closest('.tr-quote__radio').classList.add('is-disabled');
    } else {
      cuno.disabled = false;
      cuno.closest('.tr-quote__radio').classList.remove('is-disabled');
    }
  }

  function handleTechniqueChange(changedInput) {
    var sin = getTechniqueInput('sin');
    var allInputs = Array.prototype.slice.call(drawer.querySelectorAll('.tr-quote-technique-input'));
    var key = changedInput.getAttribute('data-technique');

    if (key === 'sin' && changedInput.checked) {
      allInputs.forEach(function (input) {
        if (input !== sin) input.checked = false;
      });
    } else if (key !== 'sin' && changedInput.checked) {
      sin.checked = false;
    } else if (key !== 'sin' && !changedInput.checked) {
      var anyOtherChecked = allInputs.some(function (input) {
        return input !== sin && input.checked;
      });
      if (!anyOtherChecked) sin.checked = true;
    }

    updateTechniqueDisabledStates();
  }

  function setupTechniqueLogic() {
    if (!drawer) return;
    drawer.querySelectorAll('.tr-quote-technique-input').forEach(function (input) {
      input.addEventListener('change', function () {
        handleTechniqueChange(input);
        collectStep2();
      });
    });
    updateTechniqueDisabledStates();
  }

  // ------------------------- WhatsApp -------------------------

  function buildQuickWhatsappMessage() {
    var realProducts = state.products.filter(function (p) { return p.name.trim() !== ''; });
    var lines = ['Hola, quisiera cotizar:'];
    realProducts.forEach(function (p) {
      lines.push('\u2022 ' + p.qty + ' ' + p.name + (p.color ? ' ' + p.color : ''));
    });
    lines.push('');
    var companyEl = document.getElementById('tr-quote-company');
    var nameEl = document.getElementById('tr-quote-name');
    var company = companyEl ? companyEl.value.trim() : '';
    var name = nameEl ? nameEl.value.trim() : '';
    if (company) lines.push('Empresa: ' + company);
    if (name) lines.push('Nombre: ' + name);
    lines.push('');
    lines.push('Quedo atento/a a más información.');
    return lines.join('\n');
  }

  function buildFinalWhatsappMessage() {
    collectStep1(true);
    collectStep2();
    var realProducts = state.products.filter(function (p) { return p.name.trim() !== ''; });
    var c = state.contact || {};
    var lines = ['Hola, quisiera solicitar una cotización para TRAUKO Empresas.', ''];

    lines.push('PRODUCTOS');
    realProducts.forEach(function (p) {
      lines.push('\u2022 ' + p.qty + ' ' + p.name + (p.color ? ' ' + p.color : ''));
    });
    lines.push('');

    if (state.technique && state.technique !== 'Sin personalización') {
      lines.push('PERSONALIZACIÓN');
      lines.push('\u2022 ' + state.technique);
      lines.push('');
    }
    if (state.services && state.services.length) {
      lines.push('SERVICIOS');
      state.services.forEach(function (s) { lines.push('\u2022 ' + s); });
      lines.push('');
    }
    if (c.date) { lines.push('FECHA IDEAL'); lines.push(c.date); lines.push(''); }
    if (c.budget) { lines.push('PRESUPUESTO'); lines.push(c.budget); lines.push(''); }
    if (c.objective) { lines.push('OBJETIVO'); lines.push(c.objective); lines.push(''); }
    if (c.notes) { lines.push('\u00bfQU\u00c9 DEBEMOS SABER?'); lines.push(c.notes); lines.push(''); }

    if (c.name) lines.push('Nombre: ' + c.name);
    if (c.company) lines.push('Empresa: ' + c.company);

    return lines.join('\n');
  }

  function openWhatsapp(text) {
    var url = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(text);
    window.open(url, '_blank', 'noopener');
  }

  // ------------------------- Recolectar datos -------------------------

  function collectStep1(silent) {
    var companyEl = document.getElementById('tr-quote-company');
    var nameEl = document.getElementById('tr-quote-name');
    var emailEl = document.getElementById('tr-quote-email');
    if (!companyEl || !nameEl || !emailEl) return;

    state.contact = state.contact || {};
    state.contact.company = companyEl.value;
    state.contact.name = nameEl.value;
    var contactValue = emailEl.value.trim();
    if (contactValue.indexOf('@') !== -1) {
      state.contact.email = contactValue;
    } else if (contactValue) {
      state.contact.phone = contactValue;
    }
    state.contact.contact_raw = contactValue;
    saveState();
  }

  function collectStep2() {
    if (!drawer) return;

    var checkedTechniques = Array.prototype.slice.call(drawer.querySelectorAll('.tr-quote-technique-input:checked')).map(function (cb) { return cb.value; });
    if (checkedTechniques.length === 0) checkedTechniques = ['Sin personalización'];
    state.techniques = checkedTechniques;
    state.technique = checkedTechniques.join(', ');

    state.services = Array.prototype.slice.call(drawer.querySelectorAll('input[name="tr_services"]:checked')).map(function (cb) { return cb.value; });
    state.contact = state.contact || {};
    var dateEl = document.getElementById('tr-quote-date');
    var objectiveEl = document.getElementById('tr-quote-objective');
    var notesEl = document.getElementById('tr-quote-notes');
    if (dateEl) state.contact.date = dateEl.value;
    if (objectiveEl) state.contact.objective = objectiveEl.value;
    if (notesEl) state.contact.notes = notesEl.value;
    saveState();
  }

  function restoreFormFields() {
    var c = state.contact || {};
    var map = {
      'tr-quote-company': c.company, 'tr-quote-name': c.name, 'tr-quote-email': c.contact_raw || c.email || c.phone,
      'tr-quote-date': c.date, 'tr-quote-objective': c.objective, 'tr-quote-notes': c.notes
    };
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el && map[id]) el.value = map[id];
    });

    var techniques = (state.techniques && state.techniques.length) ? state.techniques : ['Sin personalización'];
    drawer.querySelectorAll('.tr-quote-technique-input').forEach(function (cb) {
      cb.checked = techniques.indexOf(cb.value) !== -1;
    });
    updateTechniqueDisabledStates();

    drawer.querySelectorAll('input[name="tr_services"]').forEach(function (cb) {
      cb.checked = state.services.indexOf(cb.value) !== -1;
    });
  }

  function validateStep1() {
    var hasProduct = state.products.some(function (p) { return p.name.trim() !== ''; });
    if (!hasProduct) { alert('Agrega al menos un producto antes de continuar.'); return false; }

    var company = document.getElementById('tr-quote-company');
    var name = document.getElementById('tr-quote-name');
    var contact = document.getElementById('tr-quote-email');

    if (!company.value.trim()) { company.focus(); alert('Ingresa el nombre de tu empresa.'); return false; }
    if (!name.value.trim()) { name.focus(); alert('Ingresa tu nombre.'); return false; }
    if (!contact.value.trim()) { contact.focus(); alert('Ingresa tu email o teléfono para poder contactarte.'); return false; }

    collectStep1();
    return true;
  }

  // ------------------------- Resumen paso 3 -------------------------

  function renderReview() {
    var el = document.getElementById('tr-quote-review');
    if (!el) return;
    var c = state.contact || {};
    var realProducts = state.products.filter(function (p) { return p.name.trim() !== ''; });

    var groups = [];

    groups.push(
      '<div class="tr-quote-review__group"><p class="tr-quote-review__group-title">Producto</p>' +
      realProducts.map(function (p) {
        return '<p>' + escapeHtml(p.name) + (p.color ? ' \u2014 ' + escapeHtml(p.color) : '') + ' \u00b7 ' + p.qty + ' unidades</p>';
      }).join('') +
      '</div>'
    );

    var persoLines = [];
    if (state.technique) persoLines.push('<p>' + escapeHtml(state.technique) + '</p>');
    if (state.services && state.services.length) persoLines.push('<p>' + escapeHtml(state.services.join(', ')) + '</p>');
    if (persoLines.length) {
      groups.push('<div class="tr-quote-review__group"><p class="tr-quote-review__group-title">Personalización</p>' + persoLines.join('') + '</div>');
    }

    if (c.date) groups.push('<div class="tr-quote-review__group"><p class="tr-quote-review__group-title">Fecha ideal</p><p>' + escapeHtml(c.date) + '</p></div>');
    if (c.objective) groups.push('<div class="tr-quote-review__group"><p class="tr-quote-review__group-title">Objetivo</p><p>' + escapeHtml(c.objective) + '</p></div>');
    if (c.notes) groups.push('<div class="tr-quote-review__group"><p class="tr-quote-review__group-title">\u00bfQu\u00e9 debemos saber?</p><p>' + escapeHtml(c.notes) + '</p></div>');

    el.innerHTML = groups.join('');
  }

  // ------------------------- Navegación -------------------------

  function goToStep(step) {
    drawer.querySelectorAll('.tr-quote__step').forEach(function (sec) {
      sec.hidden = sec.dataset.step !== String(step);
    });
    drawer.querySelectorAll('.tr-quote__stepper-item').forEach(function (li) {
      var i = parseInt(li.dataset.stepIndicator, 10);
      li.classList.toggle('is-active', i === step);
      li.classList.toggle('is-done', i < step);
    });

    if (step === 3) {
      collectStep1(true);
      collectStep2();
      renderReview();
    }

    renderSidebarCart();
    currentStep = step;
    var body = drawer.querySelector('.tr-quote__body');
    if (body) body.scrollTop = 0;
  }

  // ------------------------- Envío de la cotización (Cloudflare Worker + Resend) -------------------------
  // Sin cambios respecto a la versión anterior: un solo POST JSON al Worker,
  // que envía ambos correos y devuelve el resultado real de cada uno.

  function submitQuote() {
    collectStep1(true);
    collectStep2();

    var submitBtn = document.getElementById('tr-quote-submit-email');
    var errorEl = document.getElementById('tr-quote-error');
    var successEl = document.getElementById('tr-quote-success');
    errorEl.hidden = true;
    successEl.hidden = true;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';

    var c = state.contact || {};
    var realProducts = state.products.filter(function (p) { return p.name.trim() !== ''; });
    var totalUnits = realProducts.reduce(function (sum, p) { return sum + (parseInt(p.qty, 10) || 0); }, 0);

    fetch(WORKER_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        contact: {
          name: c.name || '',
          email: c.email || '',
          phone: c.phone || '',
          company: c.company || ''
        },
        products: realProducts.map(function (p) {
          return { name: p.name, color: p.color, qty: p.qty };
        }),
        totalUnits: totalUnits,
        technique: state.technique || '',
        services: state.services || [],
        date: c.date || '',
        objective: c.objective || '',
        notes: c.notes || ''
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        }).catch(function () {
          return { ok: res.ok, data: null };
        });
      })
      .then(function (result) {
        submitBtn.disabled = false;
        var data = result.data;
        var mainOk = result.ok && data && data.main && data.main.ok;

        if (mainOk) {
          var clientOk = !c.email || (data.client && data.client.ok);
          successEl.hidden = false;
          successEl.textContent = (c.email && clientOk)
            ? '\u2713 Solicitud enviada. Tambi\u00e9n enviamos una copia de tu solicitud a ' + c.email + '.'
            : (c.email
              ? '\u2713 Solicitud enviada correctamente.\nNuestro equipo recibi\u00f3 tu solicitud, pero no pudimos enviar la copia a tu correo.'
              : '\u2713 Solicitud enviada.');
          submitBtn.hidden = true;
          sessionStorage.removeItem(STORAGE_KEY);
        } else {
          console.error('Error enviando la cotización:', data);
          errorEl.hidden = false;
          submitBtn.textContent = 'Enviar solicitud';
        }
      })
      .catch(function (err) {
        console.error('Error enviando la cotización:', err);
        submitBtn.disabled = false;
        errorEl.hidden = false;
        submitBtn.textContent = 'Enviar solicitud';
      });
  }

  // ------------------------- Abrir / cerrar (única fuente de verdad) -------------------------

  function openQuoteModal() {
    if (!drawer) drawer = document.getElementById('tr-quote-drawer');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    goToStep(currentStep);
  }

  function closeQuoteModal() {
    if (!drawer) drawer = document.getElementById('tr-quote-drawer');
    if (!drawer) return;
    drawer.hidden = true;
    drawer.style.display = 'none';
    document.body.style.overflow = '';
  }

  function addProductFromPage(data) {
    if (!data || !data.name || !data.name.trim()) return false;
    loadState();

    var qty = parseInt(data.qty, 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    var incomingId = (data.id !== undefined && data.id !== null) ? String(data.id).trim() : '';
    var entry = { id: incomingId, name: data.name.trim(), color: (data.color || '').trim(), qty: qty, image: data.image || '' };

    var existingIndex = -1;
    for (var i = 0; i < state.products.length; i++) {
      var p = state.products[i];
      var sameById = incomingId && p.id && String(p.id) === incomingId;
      var sameByNameColor = (!incomingId || !p.id) &&
        p.name.trim().toLowerCase() === entry.name.toLowerCase() &&
        (p.color || '').trim().toLowerCase() === entry.color.toLowerCase();
      if (sameById || sameByNameColor) {
        existingIndex = i;
        break;
      }
    }

    if (existingIndex !== -1) {
      state.products[existingIndex].qty = (parseInt(state.products[existingIndex].qty, 10) || 0) + qty;
      if (entry.image) state.products[existingIndex].image = entry.image;
      if (incomingId) state.products[existingIndex].id = incomingId;
    } else if (state.products.length === 1 && state.products[0].name.trim() === '') {
      state.products[0] = entry;
    } else {
      state.products.push(entry);
    }

    saveState();
    if (drawer && !drawer.hidden) { renderProducts(); renderSidebarCart(); }
    return true;
  }

  function bindQuoteControls() {
    drawer = document.getElementById('tr-quote-drawer');
    if (!drawer) return;

    if (drawer.hasAttribute('hidden')) {
      drawer.style.display = 'none';
    }

    drawer.querySelectorAll('[data-quote-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeQuoteModal();
      });
    });

    loadState();
    renderProducts();
    renderSidebarCart();
    restoreFormFields();
    setupTechniqueLogic();

    document.getElementById('tr-quote-add-product').addEventListener('click', function () {
      state.products.push({ name: '', color: '', qty: 1, image: '' });
      renderProducts();
      renderSidebarCart();
      saveState();
    });

    document.getElementById('tr-quote-step1-next').addEventListener('click', function () {
      if (!validateStep1()) return;
      goToStep(2);
    });

    document.getElementById('tr-quote-back-to-1').addEventListener('click', function () { goToStep(1); });
    document.getElementById('tr-quote-back-to-2').addEventListener('click', function () { goToStep(2); });

    document.getElementById('tr-quote-step2-next').addEventListener('click', function () {
      collectStep2();
      goToStep(3);
    });
    document.getElementById('tr-quote-skip').addEventListener('click', function () {
      collectStep2();
      goToStep(3);
    });

    document.getElementById('tr-quote-submit-email').addEventListener('click', submitQuote);
    document.getElementById('tr-quote-submit-whatsapp').addEventListener('click', function () {
      openWhatsapp(buildFinalWhatsappMessage());
    });

    drawer.querySelectorAll('[data-whatsapp-quick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openWhatsapp(buildQuickWhatsappMessage());
      });
    });

    drawer.addEventListener('change', function (e) {
      if (e.target.matches('input[name="tr_services"]')) collectStep2();
    });
  }

  document.addEventListener('click', function (e) {
    var openTarget = e.target.closest ? e.target.closest('[data-quote-trigger]') : null;
    if (openTarget) {
      e.preventDefault();
      openQuoteModal();
      return;
    }
    var closeTarget = e.target.closest ? e.target.closest('[data-quote-close]') : null;
    if (closeTarget) {
      e.preventDefault();
      closeQuoteModal();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeQuoteModal();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuoteControls);
  } else {
    bindQuoteControls();
  }

  window.TRQuote = window.TRQuote || {};
  window.TRQuote.addProduct = addProductFromPage;
  window.TRQuote.open = openQuoteModal;
  window.TRQuote.close = closeQuoteModal;
})();
